import cls from 'classnames'
import { useCssInJs } from 'hooks/useCssInJs'
import { genIconStyle } from './styles'

import { ReactComponent as LogoText } from 'assets/svg/logo-text.svg'
import { ReactComponent as Logo32 } from 'assets/svg/logo32.svg'

interface Props {
  collapsed?: boolean
}

function Logo(props: Props) {
  const { collapsed } = props
  const prefix = 'logo'
  const { wrapSSR, hashId } = useCssInJs({
    prefix,
    styleFun: genIconStyle,
  })

  return wrapSSR(
    <div className={cls(prefix, hashId)}>
      <Logo32 />
      {collapsed ? null : <LogoText />}
    </div>
  )
}

export default Logo
